<template>
    <v-dialog
      v-model="dialogBroadcastTime"
      persistent
      width="100%">
        <v-card>
          <v-layout pa-4 mb-2 align-center style="height:50px;">
            <h3>เลือกวันและเวลาที่ต้องการบรอดแคสต์</h3>
            <v-spacer></v-spacer>
            <v-icon @click="close()">close</v-icon>
          </v-layout>
          <v-divider></v-divider>
          <v-layout align-center justify-start column style="margin-left: 10px; margin-right: 10px;">
            <v-flex xs12 sm12 md12>
              <v-layout align-start column style="margin-top:10px; margin-bottom:10px;">
                <!-- <v-flex xs12 sm12 md12>
                  <v-layout justify-start>
                    <h4 class="pr-3">
                      <span style="color:red;">*</span>
                        ประเภท :
                    </h4>
                  </v-layout>
                </v-flex> -->
                <v-flex xs12 sm12 md12>
                  <h4 class="pr-3">
                    <span style="color:red;">*</span>
                      ประเภท :
                  </h4>
                  <v-select
                    placeholder="เลือกประเภท"
                    height="20"
                    v-model="select"
                    :items="typeday"
                    single-line
                    hide-details
                    outline
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout align-start column v-if="select === 'ondate'" style="margin-top:10px; margin-bottom:10px;">
                <v-flex xs5 sm5 md5>
                  <v-layout justify-start>
                    <h4 class="pr-3">
                      <span style="color:red;">*</span>
                        วัน :
                      </h4>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <date-picker v-model="date"  placeholder="เลือกวัน" type="date" :disabled-date="notBeforeToday" >
                    <template v-slot:footer="{ emit }">
                      <div style="text-align: center">
                        <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                          วันนี้
                        </button>
                      </div>
                    </template>
                  </date-picker>
                </v-flex>
              </v-layout>
              <v-layout column align-start v-if="select === 'Emonth'" style="margin-top:10px; margin-bottom:10px;">
                <v-flex xs12 sm12 md12>
                  <v-layout justify-end >
                    <h4 class="pr-3">
                      <span style="color:red;">*</span>
                        วันในแต่ละเดือน :
                      </h4>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-select
                      v-model="selectmonth"
                      placeholder="เลือกวันในแต่ละเดือน"
                      :items="typemonth"
                      outline
                      hide-details
                    ></v-select>
                </v-flex>
              </v-layout>
              <v-layout column align-start v-if="select === 'Eweek'" style="margin-top:10px; margin-bottom:10px;">
                <v-flex xs12 sm12 md12>
                  <v-layout justify-end >
                    <h4 class="pr-3">
                      <span style="color:red;">*</span>
                        วันในแต่ละสัปดาห์ :
                    </h4>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="selectweek"
                    placeholder="เลือกวันในแต่ละสัปดาห์"
                    :items="typeweek"
                    outline
                    hide-details
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout column align-start justify-start style="margin-top:10px; margin-bottom:10px;">
                <v-flex xs5 sm5 md5>
                  <v-layout justify-end>
                    <h4 class="pr-3" >
                      <span style="color:red;">*</span>
                        เวลา :
                    </h4 >
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <date-picker v-model="date" placeholder="เลือกเวลา" format="HH:mm"  type="time"  >
                      <template slot="icon-calendar">
                        <i class="far fa-clock"  aria-hidden="true"></i>
                      </template>
                  </date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout style="margin-left: 10px; margin-right: 10px;">
            <v-flex xs12 sm12 md12>
              <v-layout row justify-center align-center>
                <v-flex xs12 sm12 md12 style="padding-left: 30px !important;">
                  <v-radio-group row v-model="radios">
                    <v-radio label="ข้อความ" value="text"></v-radio>
                    <v-radio label="ไฟล์" value="file"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
                <v-layout column justify-center align-center v-if="radios ==='text'">
                  <!-- <v-flex xs12 sm12 md12>
                    <v-layout justify-end>
                      <h4 class="pr-3">
                        <span style="color:red;">*</span>
                          ข้อความ :
                        </h4>
                    </v-layout>
                  </v-flex> -->
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    style="padding-top:10px;"
                    name="input-7-1"
                    outline
                    no-resize
                    v-model="textT"
                    placeholder="กรุณากรอกข้อความที่ต้องการบรอดแคสต์"
                  ></v-textarea>
                </v-flex>
                </v-layout>
                <!-- image/png -->
                  <input type="file" ref="fileInput" @input="onSelectfile" style="display:none"/>
                  <v-layout align-center justify-center column v-if="radios ==='file'">
                  <div class="showFile mb-2">
                    <v-flex v-if="fileName !== ''">
                      <div v-if="extension(fileName) == 'fas fa-file-image' && image_accpet === true" style="position:relative;">
                        <v-layout align-center justify-center row fill-height>
                            <img  v-if="fileUrl"  :src="fileUrl" style="height: 150px !important; width: 150px !important; display: flex; justify-content: center; margin-top:14px;" />
                        </v-layout>
                        <v-icon style="position:absolute;top:0px; right:0px;" @click="clearfile()">close</v-icon>
                      </div>
                      <div v-else style="position:relative;">
                        <v-layout align-center justify-center row fill-height v-if="image_accpet === true">
                          <v-flex style="text-align:center;">
                            <v-icon style="font-size: 80px !important; margin-top:30px;">{{extension(fileName)}}</v-icon>
                            <h5 style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color:#6c6c6c;">{{fileName}}</h5>
                          </v-flex>
                        </v-layout>
                        <v-icon style="position:absolute;top:0px; right:0px;" @click="clearfile()">close</v-icon>
                      </div>
                    </v-flex>
                    <v-flex v-if="fileName === ''" @click="chooseFile">
                      <v-layout column wrap justify-center align-center style="height: 180px;">
                        <v-btn icon color="primary">
                          <v-icon>mdi-upload</v-icon>
                        </v-btn>
                        <p style="color: grey;">เลือกไฟล์</p>
                        <span style="color: #bf0000;"> *รองรับไฟล์ .jpg .jpeg .gif .png </span>
                      </v-layout>
                    </v-flex>
                  </div>
                  <!-- <span style="color:red"> *รองรับไฟล์ .jpg .jpeg .gif .png </span> -->
                  <!-- <v-btn color="#757575" style="color:white;" class="btnChoosefile" @click="chooseFile">เลือกไฟล์</v-btn> -->
                </v-layout>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout justify-end>
            <v-btn  @click="close()" outline color="#ccc" style="color:black;">ยกเลิก</v-btn>
            <v-btn color="info" :disabled="disable()" @click="confirm()">ตกลง</v-btn>
          </v-layout>
        </v-card>
    </v-dialog>
</template>
<script>
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
  components: {
    // VueCtkDateTimePicker
    DatePicker
  },
  props: {
    dialogBroadcastTime: Boolean
  },
  data () {
    return {
      image_accpet: true,
      textT: '',
      fileUrl: '',
      fileName: '',
      radios: 'text',
      select: 'Eday',
      selectmonth: '',
      selectweek: '',
      typeday: [
        { text: 'ทุกวัน', value: 'Eday' },
        { text: 'ทุกสัปดาห์', value: 'Eweek' },
        { text: 'ทุกเดือน', value: 'Emonth' },
        { text: 'วัน', value: 'ondate' }
      ],
      // typeweek: ['วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์', 'วันอาทิตย์'],
      typeweek: [
        { text: 'วันจันทร์', value: 'Monday' },
        { text: 'วันอังคาร', value: 'Tuesday' },
        { text: 'วันพุธ', value: 'Wednesday' },
        { text: 'วันพฤหัสบดี', value: 'Thursday' },
        { text: 'วันศุกร์', value: 'Friday' },
        { text: 'วันเสาร์', value: 'Saturday' },
        { text: 'วันอาทิตย์', value: 'Sunday' }
      ],
      typemonth: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28'],
      date: null,
      menu: false,
      string_date: '',
      access_token: 'Bearer A00faf32b63b858c280058e96888a450b53458eedbbac4710951949336c0561a53ad3c7684f20428f91def8c796dc10bf',
      disabledBefore: new Date(2019, 10, 2)
      // dateCurrent: new Date().toISOString().slice(0,10),
    }
  },
  watch: {
    date () {
      if (this.date !== '') {
        const date = new Date((this.date).getTime())
        date.setHours(date.getHours() + 7)
        let stringDate = date.toISOString().replace('T', ' ')
        this.string_date = stringDate.replace('Z', '0')
        // console.log(this.string_date)
      }
    },
    dialogBroadcastTime () {
      if (this.dialogBroadcastTime === true) {
        this.clear()
      }
    }
  },
  mounted () {
    // this.formatTime()
    // console.log(this.date)
  },
  methods: {
    close () {
      this.$emit('closedialogTime', false)
    },
    clear () {
      this.time = ''
      this.date = null
      this.select = 'Eday'
      this.selectmonth = ''
      this.selectweek = ''
      this.fileName = ''
      this.textT = ''
      this.radios = 'text'
    },
    confirm () {
      if (this.select === 'ondate') {
        // เรียกใช้ฟังก์ชัน
        this.OndateBC()
      } else if (this.select === 'Emonth') {
        this.monthBC()
      } else if (this.select === 'Eweek') {
        this.weekBC()
      } else {
        this.dayBC()
      }
      // this.$emit('closedialogTime', false)
      // this.clear()
    },
    dayBC () {
      if (this.$refs.fileInput.files && this.$refs.fileInput.files[0]) {
        var typemes
        var typeMessage = this.extension(this.$refs.fileInput.files[0].name)
        if (typeMessage === 'fas fa-file-image') {
          typemes = 'image'
        } else {
          typemes = 'file'
        }
      }
      var dataFile = new FormData()
      dataFile.append('botid', localStorage.tokenbot)
      dataFile.append('time', this.string_date)
      dataFile.append('typemessage', typemes)
      dataFile.append('file', this.$refs.fileInput.files[0])
      var raw = {
        botid: localStorage.tokenbot,
        message: this.textT,
        typemessage: 'message',
        time: this.string_date
      }
      var body
      if (this.radios === 'file') {
        body = dataFile
      } else if (this.radios === 'text') {
        body = raw
      }
      this.axios.post(process.env.VUE_APP_API_BROADCAST + '/api/set/dayBroadcast', body, {
        headers: {
          Authorization: this.access_token
        }
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$swal({
            title: 'สร้างบรอดแคสต์สำเร็จ',
            type: 'success',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
          this.$emit('closedialogTime', false)
        } else {
          this.$swal({
            title: 'ไม่สามารถสร้างบรอดแคสต์ได้',
            type: 'error',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
        }
      })
    },
    monthBC () {
      if (this.$refs.fileInput.files && this.$refs.fileInput.files[0]) {
        var typemes
        var typeMessage = this.extension(this.$refs.fileInput.files[0].name)
        if (typeMessage === 'fas fa-file-image') {
          typemes = 'image'
        } else {
          typemes = 'file'
        }
      }
      var dataFile = new FormData()
      dataFile.append('botid', localStorage.tokenbot)
      dataFile.append('time', this.string_date)
      dataFile.append('dayint', this.selectmonth)
      dataFile.append('typemessage', typemes)
      dataFile.append('file', this.$refs.fileInput.files[0])
      var raw = {
        botid: localStorage.tokenbot,
        message: this.textT,
        typemessage: 'message',
        time: this.string_date
      }
      var body
      if (this.radios === 'file') {
        body = dataFile
      } else if (this.radios === 'text') {
        body = raw
      }
      this.axios.post(process.env.VUE_APP_API_BROADCAST + '/api/set/monthBroadcast', body, {
        headers: {
          Authorization: this.access_token
        }
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$swal({
            title: 'สร้างบรอดแคสต์สำเร็จ',
            type: 'success',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
          this.$emit('closedialogTime', false)
          // this.clear()
        } else {
          this.$swal({
            title: 'ไม่สามารถสร้างบรอดแคสต์ได้',
            type: 'error',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
        }
      })
    },
    weekBC () {
      if (this.$refs.fileInput.files && this.$refs.fileInput.files[0]) {
        var typemes
        var typeMessage = this.extension(this.$refs.fileInput.files[0].name)
        if (typeMessage === 'fas fa-file-image') {
          typemes = 'image'
        } else {
          typemes = 'file'
        }
      }
      var dataFile = new FormData()
      dataFile.append('botid', localStorage.tokenbot)
      dataFile.append('time', this.string_date)
      // 2021-02-28 23:00:00.0000
      dataFile.append('typemessage', typemes)
      dataFile.append('file', this.$refs.fileInput.files[0])
      dataFile.append('day', this.selectweek)
      var raw = {
        botid: localStorage.tokenbot,
        time: this.string_date,
        typemessage: 'message',
        message: this.textT,
        day: this.selectweek
      }
      var body
      if (this.radios === 'file') {
        body = dataFile
      } else if (this.radios === 'text') {
        body = raw
      }

      this.axios.post(process.env.VUE_APP_API_BROADCAST + '/api/set/weekBroadcast', body, {
        headers: {
          Authorization: this.access_token
        }
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$swal({
            title: 'สร้างบรอดแคสต์สำเร็จ',
            type: 'success',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
          this.$emit('closedialogTime', false)
          // this.clear()
        } else {
          this.$swal({
            title: 'ไม่สามารถสร้างบรอดแคสต์ได้',
            type: 'error',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    OndateBC () {
      if (this.$refs.fileInput.files && this.$refs.fileInput.files[0]) {
        var typemes
        var typeMessage = this.extension(this.$refs.fileInput.files[0].name)
        if (typeMessage === 'fas fa-file-image') {
          typemes = 'image'
        } else {
          typemes = 'file'
        }
      }
      var dataFile = new FormData()
      dataFile.append('botid', localStorage.tokenbot)
      dataFile.append('type', this.select)
      dataFile.append('time', this.string_date)
      dataFile.append('typemessage', typemes)
      dataFile.append('file', this.$refs.fileInput.files[0])
      var raw = {
        botid: localStorage.tokenbot,
        message: this.textT,
        typemessage: 'message',
        time: this.string_date
      }
      var body
      if (this.radios === 'file') {
        body = dataFile
      } else if (this.radios === 'text') {
        body = raw
      }
      this.axios.post(process.env.VUE_APP_API_BROADCAST + '/api/set/ondateBroadcast', body,
        {
          headers: {
            Authorization: this.access_token
          }
        }).then((response) => {
        if (response.data.status === 'success') {
          this.$swal({
            title: 'สร้างบรอดแคสต์สำเร็จ',
            type: 'success',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
          this.$emit('closedialogTime', false)
          // this.clear()
        } else {
          this.$swal({
            title: 'ไม่สามารถสร้างบรอดแคสต์ได้',
            type: 'error',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    setFileName () {
      this.fileName = this.$refs.fileInput.files[0].name
      var typeFile = this.$refs.fileInput.files[0].type
      this.fileData = this.$refs.fileInput.files[0]
      // console.log(this.$refs.fileTest.files[0].size / 1024 / 1024)
      if (this.$refs.fileInput.files[0].size / 1024 / 1024 > 25) {
        this.$swal({ title: 'ไฟล์ของท่านมีขนาดเกิน 25 MB', type: 'warning' })
        this.reset()
      }
      if (typeFile.search('image') !== -1) {
        var fr = new FileReader()
        fr.onload = function () {
          document.getElementById('img_file').src = fr.result
        }
        fr.readAsDataURL(this.fileData)
      }
    },
    onSelectfile (data) {
      var input = this.$refs.fileInput
      var files = input.files
      if (files[0] !== undefined) {
        this.filepath = data.target.files[0]
        this.fileName = data.target.files[0].name
        if (files && files[0]) {
          this.fileUrl = URL.createObjectURL(this.filepath)
        }
        // check type file or image
        this.acceptFile(this.fileName)
      }
    },
    acceptFile (files) {
      var extensionfile = files.split('.')[files.split('.').length - 1].toLowerCase()
      var imageNot = ['bmp', 'ico', 'svg', 'tif', 'tiff']
      if (imageNot.includes(extensionfile)) {
        this.image_accpet = false
        this.$swal({
          title: 'กรุณาเลือกไฟล์ที่ถูกต้อง',
          type: 'warning',
          showConfirmButton: true
        }).then((result) => {
          if (result.value === true) {
            this.fileName = ''
          }
        })
      } else {
        this.image_accpet = true
      }
    },
    extension (files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm', 'xlsx']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
    // return extension[extension.length-1]
    },
    chooseFile () {
      this.$refs.fileInput.click()
    },
    disable () {
      if (this.select === '') {
        return true
      } else {
        if (this.select === 'Eday') {
          if (this.date !== null && (this.textT !== '' || this.fileName !== '')) {
            return false
          } else {
            return true
          }
        } else if (this.select === 'Eweek') {
          if (this.date !== null && this.selectweek !== '' && (this.textT !== '' || this.fileName !== '')) {
            return false
          } else {
            return true
          }
        } else if (this.select === 'Emonth') {
          if (this.selectmonth !== '' && this.date !== null && (this.textT !== '' || this.fileName !== '')) {
            return false
          } else {
            return true
          }
        } else if (this.select === 'ondate') {
          if (this.date !== null && this.date !== null && (this.textT !== '' || this.fileName !== '')) {
            return false
          } else {
            return true
          }
        }
      }
    },
    clearfile () {
      this.fileName = ''
    },
    notBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    }
  }
}
</script>
<style scoped>
>>>.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
    padding-top: 0px !important;
}
>>>.mx-input {
    height: 56px !important;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
}
>>>.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
    border: 1px solid #ccc !important;
}
>>>.v-btn.v-btn--outline {
    border: 1px solid #ccc;
}
>>>::placeholder {
  color: #b1b1b1;
  opacity: 1;
}
.showFile{
  width: 200px;
  height: 180px;
  border: 2px solid  #ccc;
  position: relative;
}
.top-right {
  position: absolute;
  top: 8px;
  right: 16px;
}

</style>
